module.exports.fix = function() {
  CKEDITOR.editable.prototype.setData = function(a, b) {
    b || (a = this.editor.dataProcessor.toHtml(a));
    this.fixInitialSelection();
    'unloaded' === this.status && (this.status = 'ready');
    this.editor.fire('dataReady');
  };
};
